import { render, staticRenderFns } from "./EventoInscricaoForm.vue?vue&type=template&id=7059096d&scoped=true&"
import script from "./EventoInscricaoForm.vue?vue&type=script&lang=js&"
export * from "./EventoInscricaoForm.vue?vue&type=script&lang=js&"
import style0 from "./EventoInscricaoForm.vue?vue&type=style&index=0&id=7059096d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7059096d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VIcon,VRadio,VRadioGroup,VRow,VSheet,VTextField,VTextarea})
